import { ListGroup } from 'reactstrap';
import SearchInput from './SearchInput';
import PracticesList from './PracticesList';
import NewPracticeButton from './NewPracticeButton';

const listHeight = '400px';

const SearchPractices = () => {
    return (
        <>
            <SearchInput />

            <ListGroup
                className="w-100 mx-auto text-dark"
                style={{
                    minHeight: listHeight,
                    maxHeight: listHeight,
                    overflowY: 'auto',
                }}>

                <NewPracticeButton />

                <PracticesList />

            </ListGroup>
        </>
    );
};

export default SearchPractices;
